
<template>
    <div>
        <canvas class="celebration" v-celebration="{ type, color, delay }"></canvas>
    </div>
</template>


<script>
import * as fireworks from './fireworks'
import * as confetti from './confetti'

export default {
    components: {},
    props: {
        color: {
            type: String,
            required: false,
            default: 'default'
        },
        delay: {
            type: Number,
            required: false,
            default: 100
        },
        type: {
            type: String,
            required: false,
            default: 'confetti'
        }
    },
    vuex: {
        getters: {},
        actions: {}
    },
    directives: {
        celebration: {
            bind: function(el, binding) {

                // Start delay
                setTimeout( () => {
                    if (binding.value.type === 'confetti') {
                        confetti.start(el, binding.value.color);
                    } else {
                        fireworks.start(el);
                    }
                }, binding.value.delay || 100)

                // Finish delay
                setTimeout( () => {
                    if (binding.value.type === 'confetti') {
                        confetti.stop();
                    } else {
                        fireworks.stop();
                    }
                    if (el != null) {
                        el.style.opacity = 0
                    }
                }, 10000);


            }

        }

    }

}
</script>


<style lang="scss">

    @import 'global';

    .celebration {
        position: fixed;
        left: 0;
        top: 0;
        z-index: $z-index-celebration;
        border: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        transition: opacity 2s ease-in;
    }

</style>



// WEBPACK FOOTER //
// Celebration.vue?5964ef9a